import styled from 'styled-components/macro';

export const ContainerTeamContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TeamBlockContent = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Season = styled.span`
  text-transform: uppercase;
  margin-right: 5px;
`;

export const TeamSeasonLabel = styled.span`
  display: block;
  text-transform: uppercase;
  font-size: 9px;
  margin-bottom: 5px;
  font-family: ${({ theme }) => theme.primaryFontLight};
`;
export const TeamSeason = styled.span`
  display: block;
  font-size: 13px;
  font-family: ${({ theme }) => theme.primaryFontBold};
`;
